<template>
    <div class="members">
        <div class="index-con">
            <!-- <img class="index-img" src="@/assets/images/new-018.jpg" alt="" /> -->
            <div class="router">
                <span>IRADSTM</span> <b>→</b> <span>会员</span> <b>→</b>
                <span>个人会员名单</span>
            </div>
            <div class="box-title">IRADSTM个人会员名单</div>
            <div class="nav-title">
                <div class="list" v-for="item in navList" :class="current == item ? 'active' : ''"
                    @click="changeNavFn(item)" :key="item">{{ item }}</div>
            </div>
            <div class="lists">
                <div class="title">
                    {{ current }}
                </div>
                <el-table stripe :data="tableList" class="gray-header">
                    <el-table-column prop="name" width="300px" label="Name"></el-table-column>
                    <el-table-column prop="sex" width="100px" label="F/M"></el-table-column>
                    <el-table-column prop="country" width="200px" label="Country"></el-table-column>
                    <el-table-column prop="institution" width="500px" label="Institution"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "membersList",
    data() {
        return {
            navList: [
                "A", 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
            ],
            current: 'A',
            list: [],
            tableList: []
        };
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList() {
            this.$http.members_list({
                page: 1,
                pagesize: 300
            }).then(res => {
                let arr = res.data
                let lists = this.navList.map(item => {
                    return {
                        name: item,
                        children: arr.filter(name => name.name.trim()[0] == item)
                    }
                })
                this.list = lists;
                this.tableList = this.list[0].children
            })
        },
        changeNavFn(item) {
            this.current = item
            this.tableList = this.list.filter(item => item.name == this.current)[0].children

        }
    },
}
</script>
<style scoped lang="less">
.index-con {
    width: 1200px;
    margin: 0 auto;
}

.nav-title {
    display: flex;
    position: relative;
    top: -1px;
    z-index: 2;

    .list {
        width: 30px;
        color: #333;
        border-radius: 3px 3px 0 0;
        margin: 0 3px;
        height: 40px;
        background: #f1f1f1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .list.active {
        border: 1px solid #999;
        border-bottom: 1px solid #fff;
        background: #fff;
    }

    .list:nth-of-type(1) {
        margin-left: 0;
    }
}

.lists {
    position: relative;
    border: 1px solid #999;
    margin-top: -2px;
    z-index: 1;
    padding: 15px;
    box-sizing: border-box;

    .title {
        font-size: 28px;
        font-weight: 500;
        color: #5b965a;
    }
}

.index-img {
    width: 100%;
    height: auto;
}

.box-title {
    text-align: center;
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;
    width: 100%;
    margin-top: 50px;

    &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 400px;
        max-width: 100%;
        height: 6px;
        background-color: #5b965a;
    }
}

@media screen and (max-width: 768px) {


    .index-con {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;

        .box-title-big {
            font-size: 20px;
        }

        .box-title {
            font-size: 18px;
        }

    }

    .nav-title .list {
        font-size: 12px;
        margin: 0;
        border-radius: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/membersList.vue